import { Controller } from 'react-hook-form';
import { FC } from 'react';

import { AboutFormControlProps } from '../../types';
import { CollapseCheckbox } from '../components/collapseCheckbox';
import { Termostatstyring } from '../../../../../utils/registerEnums';
import { TermostatstyringRadio } from '../components/termostatstyringRadio';
import { useAboutFormContext } from '../../utils';

export const OljeKamin: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue, trigger } = useAboutFormContext();
  return (
    <Controller
      name="oppvarming.oppvarmingOlje.kamin.selected"
      control={control}
      render={({ field, fieldState }) => (
        <CollapseCheckbox
          labelKey="register.tekniskUtstyr.oljeKamin.label"
          checked={!!field.value}
          onChange={(checked) => {
            field.onChange(checked);

            const newValue = checked ? { termostatstyring: Termostatstyring.Ukjent } : undefined;

            setValue('oppvarming.oppvarmingOlje.kamin.value', newValue);
            trigger('oppvarmingSelection.oppvarmingOlje');
          }}
          error={!!fieldState.error}
        >
          <Controller
            name="oppvarming.oppvarmingOlje.kamin.value"
            control={control}
            render={({ field: { value, onChange }, fieldState }) => (
              <TermostatstyringRadio
                value={value?.termostatstyring}
                labelKey="register.termostatstyring.label"
                informationKey="register.termostatstyring.kamin.information"
                error={fieldState.error}
                onChange={(val) =>
                  onChange({
                    termostatstyring: val as Termostatstyring
                  })
                }
              />
            )}
          />
        </CollapseCheckbox>
      )}
    />
  );
};
